import { render } from "./LoginInit.vue?vue&type=template&id=242e1eba"
import script from "./LoginInit.vue?vue&type=script&lang=js"
export * from "./LoginInit.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\cloud_share_lib\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__